// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.ant-progress-status-success .ant-progress-bg {\n  background-color: #1890ff; }\n", ""]);
// Exports
module.exports = exports;
